<template>
  <div class="three-dimension-container">
    <div id="container"></div>
    
    <div class="title">二白机器人 · 数字生命体领养中心</div>
    
    <div class="controls" :class="{ 'collapsed': isControlsCollapsed }">
      <h2>调试窗口</h2>
      <div class="toggle-controls" @click="toggleControls">
        <div class="hamburger">
          <div class="bar"></div>
        </div>
      </div>
      <div class="control-group">
        <label for="rotationSpeed">旋转速度</label>
        <input type="range" id="rotationSpeed" v-model="rotationSpeed" min="0" max="1" step="0.05" @input="updateRotationSpeed">
        <div class="value-display">当前速度: <span id="speedValue">{{ rotationSpeed.toFixed(2) }}</span></div>
      </div>
      <div class="control-group">
        <label for="particleSize">粒子大小</label>
        <input type="range" id="particleSize" v-model="particleSize" min="0.1" max="2" step="0.1" @input="updateParticleSize">
        <div class="value-display">当前大小: <span id="sizeValue">{{ particleSize.toFixed(1) }}</span></div>
      </div>
      <div class="control-group">
        <label for="particleCount">粒子数量</label>
        <input type="range" id="particleCount" v-model="particleCount" min="5" max="2000" step="10" @input="updateParticleCount">
        <div class="value-display">当前数量: <span id="countValue">{{ particleCount }}</span></div>
      </div>
      <div class="control-group">
        <label for="distanceFactor">分布范围</label>
        <input type="range" id="distanceFactor" v-model="distanceFactor" min="1" max="30" step="1" @input="updateDistanceFactor">
        <div class="value-display">当前范围: <span id="distValue">{{ distanceFactor }}</span></div>
      </div>
      <div class="control-group">
        <label for="cameraDistance">观测距离</label>
        <input type="range" id="cameraDistance" v-model="cameraDistance" min="10" max="80" step="1" @input="updateCameraDistance">
        <div class="value-display">当前距离: <span id="cameraValue">{{ cameraDistance }}</span></div>
      </div>
      <div class="control-group">
        <label for="textThreshold">标签显示数量</label>
        <input type="range" id="textThreshold" v-model="textThreshold" min="0" max="50" step="1" @input="updateTextThreshold">
        <div class="value-display">显示数量: <span id="textThresholdValue">{{ textThreshold }}</span></div>
      </div>
      <button class="btn1" @click="handleButtonClick(1)">开屏动画</button>
      <button class="btn1" @click="handleButtonClick(2)">真实加载</button>
      <select class="select-menu" v-model="selectedPersonality" @change="handlePersonalityChange">
        <option value="1">小干部</option>
        <option value="2">佛系</option>
        <option value="3">脑洞大</option>
        <option value="4">爱出点子</option>
        <option value="5">社交悍匪</option>
        <option value="6">乖巧</option>
        <option value="7">活泼</option>
        <option value="8">粘人</option>
        <option value="9">情绪稳定</option>
        <option value="10">乐天派</option>
        <option value="11">热心肠</option>
        <option value="12">脑路新奇</option>
      </select>
      <button class="btn1" @click="handleButtonClick(3)">选词减生命体</button>
      <button class="btn1" @click="handleButtonClick(4)">去词加生命体</button>
      <button id="resetBtn" class="btn" @click="init('system')">创建/重置星系</button>
    </div>
    <div class="info" id="info">等待选择<div id="keywords"></div>
    </div>

    <!-- 新增日期和按钮组件 -->
    <div class="date-button-container" :class="{ 'collapsed': isDateContainerCollapsed }">
      <button class="toggle-btn" @click="toggleDateContainer">{{ isDateContainerCollapsed ? '展开' : '收起' }}</button>
      <div>当前星座：{{ currentZodiac }}</div><br>
      <input type="date" id="datePicker" class="date-picker" v-model="selectedDate" @change="handleDateChange">
      <div class="button-grid">
        <button v-for="(keyword, index) in keywords" :key="index" class="keyword-btn" :class="{ 'selected': selectedKeywords.includes(keyword) }" @click="handleKeywordButtonClick(keyword, $event.target)" :disabled="isKeywordDisabled(keyword)">
          {{ keyword }}
        </button>
      </div>
      <br>
      <button id="selectLifeForm" class="btn1" :disabled="final_selected.id === 0" @click="selectLifeForm">选择当前生命体</button>
    </div>

    <!-- 验证码弹窗 -->
    <div id="codeModal" class="modal-container" v-if="showCodeModal">
      <div class="modal-content modal-content-container">
        <b>生命体密钥</b>
        <br>
        <div style="font-size: 0.8em;">请在小程序种填写密钥</div>
        <div style="font-size: 0.8em;">锁定该生命体</div>
        <br>
        <div class="code-display">
          <div v-for="(digit, index) in codeDigits" :key="index" class="code-digit">{{ digit }}</div>
        </div>
        <div class="modal-buttons">
          <button class="btn1" @click="copyCode">复制</button>
          <button class="btn1" @click="closeCodeModal">关闭</button>
        </div>
      </div>
    </div>

    <!-- 信息弹窗 -->
    <div id="infoModal" class="modal-container" v-if="showInfoModal">
      <div class="modal-content modal-content-container" id="modalContent" style="max-width:300px; min-height:200px; max-height:70vh;">
        <div class="scroll-content" style="overflow-y:auto; padding-right:10px; flex-grow:1;">
          <h3 style="color:#4ecca3; margin-bottom:15px;">领养说明</h3>
          <p style="text-align:left; line-height:2; margin-bottom:25px; font-size: small;" v-html="infoModalContent"></p>
        </div>
        <div class="modal-buttons" style="margin-top:20px; padding-bottom:15px; width:100%; display:flex; justify-content:flex-end;">
          <button class="btn1" @click="closeInfoModal">关闭</button>
        </div>
      </div>
    </div>

    <audio id="audioPlayer" class="hidden-audio" ref="audioPlayer"></audio>
  </div>
</template>

<script>
import * as THREE from 'three'
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js'
import * as TWEEN from '@tweenjs/tween.js'
import request from '@/utils/request'

export default {
  name: 'ThreeDimensionalPersonality',
  data() {
    return {
      // Three.js 相关
      scene: null,
      camera: null,
      renderer: null,
      labelRenderer: null,
      particlesGroup: null,
      glowMeshes: [],
      celestialGroup: null,
      lightGroup: null,
      rings: [],
      centerGlow: null,
      clock: null,
      animationId: null,
      targetCameraPosition: new THREE.Vector3(20, 10, 30),
      labelCache: {},
      visibleLabels: [],
      final_selected: { id: 0 },
      
      // 控制参数
      rotationSpeed: 1.0,
      baseRotationSpeed: 1.0,
      particleSize: 0.3,
      baseParticleSize: 0.3,
      particleCount: 100,
      baseParticleCount: 100,
      distanceFactor: 15,
      baseDistanceFactor: 15,
      cameraDistance: 30,
      baseCameraDistance: 30,
      textThreshold: 10,
      baseMaxVisibleLabels: 10,
      isControlsCollapsed: false,
      keywordMode: false,
      particles_deleted: [],
      
      // 日期和星座
      selectedDate: '',
      currentZodiac: '',
      isDateContainerCollapsed: false,
      
      // 关键词
      keywords: [
        '小干部', '佛系', '脑洞大', '爱出点子',
        '社交悍匪', '乖巧', '活泼', '粘人',
        '情绪稳定', '乐天派', '热心肠', '脑路新奇'
      ],
      selectedKeywords: [],
      
      // 弹窗
      showCodeModal: false,
      codeDigits: ['1', '2', '3', '4', '5', '6'],
      showInfoModal: false,
      infoModalContent: '',
      
      // 其他
      selectedPersonality: '1',
      zodiacMap: {
        '白羊座': ['乐天派'],
        '金牛座': ['情绪稳定'],
        '双子座': ['脑路新奇'],
        '巨蟹座': ['热心肠'],
        '狮子座': ['乐天派'],
        '处女座': ['情绪稳定'],
        '天秤座': ['热心肠'],
        '天蝎座': ['脑路新奇'],
        '射手座': ['乐天派'],
        '摩羯座': ['情绪稳定'],
        '水瓶座': ['脑路新奇'],
        '双鱼座': ['热心肠']
      },
      exclusiveGroups: [
        ['小干部', '佛系'],
        ['社交悍匪', '乖巧']
      ],
      zodiacButtons: ['情绪稳定', '乐天派', '热心肠', '脑路新奇'],
      livingInfos: [],
      living_infos_default: [],
      isLoading: false,
      ringConfigs: [
        [2.1, 2.13, 0xffffff, 0.5, -0.1 * Math.PI],
        [2.6, 2.615, 0xffffff, 0.4, -0.15 * Math.PI],
        [2.82, 2.835, 0xffffff, 0.1, -0.2 * Math.PI],
        [2.9, 2.915, 0xffffff, 0.2, -0.25 * Math.PI],
        [3.8, 3.815, 0xffffff, 0.1, -0.3 * Math.PI]
      ],
      colors: [
        0x4ecca3, 0xfc5185, 0x3fc1c9,
        0xffbe0b, 0xfb5607, 0x8338ec,
        0x006edc, 0xff006e, 0x0bde8c,
        0xf15bb5, 0x00bbf9, 0x9b5de5
      ],
      
      // 交互相关
      isDragging: false,
      isPointerInControls: false,
      previousMousePosition: { x: 0, y: 0 },
      touchStartDistance: 0,
      initialTouchPosition: { x: 0, y: 0 },
      
      // 标签显示控制
      lastLabelUpdateTime: 0,
      labelUpdateInterval: 2000, // 标签更新间隔（毫秒）
      
      // 音频相关
      isPlaying: false,
      audioDefaultUrl: 'https://robot-rby.oss-cn-hangzhou.aliyuncs.com/rby-chat/audio_mp3/%E5%93%8E%E5%91%80-50.mp3'
    }
  },
  mounted() {
    this.init('system')
    this.setupDatePicker()
    this.getLivingInfos()
    this.setupEventListeners()
    this.showInfo(`
      欢迎来到二白数字生命体领养中心，在挑选你的二白之前，可以仔细阅读以下内容：<br>
      1、生命体中心默认显示当天的生命体，可以选择其他时间的生命体<br>
      2、您可以通过选择性格特征，来缩小生命体范围，最多可以选择三个关键词<br>
      3、部分性格特征和星座有关联，需要在对应的星座内才可选择哦<br>
      4、点击小球上方文字标签即可选中生命体，然后点击下方按钮，即可获得"生命体密钥"，返回小程序，输入密钥，即可继续领养步骤哦
    `)
  },
  beforeDestroy() {
    this.cleanup()
  },
  methods: {
    init(_type) {
      const container = document.getElementById('container')
      
      // 场景
      this.scene = new THREE.Scene()
      
      // 时钟
      this.clock = new THREE.Clock()
      
      // 相机
      this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000)
      this.camera.position.set(20, 10, 30)
      this.targetCameraPosition = new THREE.Vector3(20, 10, 30)
      
      // 渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
      container.appendChild(this.renderer.domElement)
      
      // 标签渲染器
      this.labelRenderer = new CSS2DRenderer()
      this.labelRenderer.setSize(window.innerWidth, window.innerHeight)
      this.labelRenderer.domElement.style.position = 'absolute'
      this.labelRenderer.domElement.style.top = '0px'
      this.labelRenderer.domElement.style.pointerEvents = 'none'
      container.appendChild(this.labelRenderer.domElement)
      
      // 光源组
      this.lightGroup = new THREE.Group()
      
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.3)
      this.lightGroup.add(ambientLight)
      
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
      directionalLight.position.set(0, 30, 0)
      this.lightGroup.add(directionalLight)
      
      const topLight = new THREE.DirectionalLight(0xFFDD99, 0.4)
      topLight.position.set(0, 1, 0.5)
      this.lightGroup.add(topLight)
      
      const leftLight1 = new THREE.DirectionalLight(0x7733FF, 0.4)
      leftLight1.position.set(-2, 0, 0)
      this.lightGroup.add(leftLight1)
      
      const leftLight2 = new THREE.DirectionalLight(0xFF33FF, 0.4)
      leftLight2.position.set(-2, -2, 2)
      this.lightGroup.add(leftLight2)
      
      const rightLight = new THREE.DirectionalLight(0xFF4466, 0.9)
      rightLight.position.set(2, -1.2, 1)
      this.lightGroup.add(rightLight)
      
      const buttomLight = new THREE.DirectionalLight(0xFFDD99, 0.2)
      buttomLight.position.set(0, -2, 0.5)
      this.lightGroup.add(buttomLight)
      
      this.scene.add(this.lightGroup)
      this.lightGroup.position.set(0, 0, 0)
      
      // 天体组
      this.celestialGroup = new THREE.Group()
      
      // 中心点（星系核心）
      const centerGeometry = new THREE.SphereGeometry(1.8, 64, 64)
      const centerMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        roughness: 1,
        metalness: 0.1,
        transparent: true,
        opacity: 1
      })
      const centerPoint = new THREE.Mesh(centerGeometry, centerMaterial)
      this.celestialGroup.add(centerPoint)
      this.celestialGroup.add(this.lightGroup)
      this.scene.add(this.celestialGroup)
      
      // 添加贴图平面
      const textureLoader = new THREE.TextureLoader()
      const planetTexture = textureLoader.load(require('@/assets/planet.png'), () => {
        //console.log('贴图加载完成');
      })

      const planetMaterial = new THREE.MeshBasicMaterial({
        map: planetTexture,
        transparent: true,
        side: THREE.DoubleSide,
        opacity: 0.8
      })
      const planetGeometry = new THREE.CircleGeometry(1.4, 32)
      const planetMesh = new THREE.Mesh(planetGeometry, planetMaterial)
      planetMesh.position.set(0, 0, 2)
      this.lightGroup.add(planetMesh)
      
      // 中心光晕
      const glowTexture = this.generateGlowTexture(128, 128)
      const centerGlowMaterial = new THREE.SpriteMaterial({
        map: glowTexture,
        color: 0xff9966,
        transparent: true,
        blending: THREE.AdditiveBlending,
        opacity: 0.9
      })
      this.centerGlow = new THREE.Sprite(centerGlowMaterial)
      this.centerGlow.scale.set(5.0, 5.0, 1.0)
      this.scene.add(this.centerGlow)
      
      // 创建光环
      this.createRings()
      
      // 粒子组
      this.particlesGroup = new THREE.Group()
      this.scene.add(this.particlesGroup)
      
      // 初始化参数
      if (_type == "system") {
        this.particleCount = this.baseParticleCount
        this.createParticles(this.particleCount)
      }
      else if (_type == "real_data") {
        this.keywordMode = true
        this.particleCount = this.livingInfos.length
        this.createParticles(this.particleCount, this.livingInfos)
      }

      this.rotationSpeed = this.baseRotationSpeed
      this.particleSize = this.baseParticleSize
      this.cameraDistance = this.baseCameraDistance
      this.targetCameraPosition.setLength(this.cameraDistance)
      this.distanceFactor = this.baseDistanceFactor
      this.textThreshold = this.baseMaxVisibleLabels

      // 更新UI控件
      if (document.getElementById('rotationSpeed')) {
        document.getElementById('rotationSpeed').value = this.rotationSpeed
        document.getElementById('speedValue').textContent = this.rotationSpeed + ''
      }

      if (document.getElementById('particleSize')) {
        document.getElementById('particleSize').value = this.particleSize
        document.getElementById('sizeValue').textContent = this.particleSize + ''
      }

      if (document.getElementById('cameraDistance')) {
        document.getElementById('cameraDistance').value = this.cameraDistance
        document.getElementById('cameraValue').textContent = this.cameraDistance + ''
      }

      if (document.getElementById('particleCount')) {
        document.getElementById('particleCount').value = this.particleCount
        document.getElementById('countValue').textContent = this.particleCount + ''
      }

      if (document.getElementById('distanceFactor')) {
        document.getElementById('distanceFactor').value = this.distanceFactor
        document.getElementById('distValue').textContent = this.distanceFactor + ''
      }

      if (document.getElementById('textThreshold')) {
        document.getElementById('textThreshold').value = this.textThreshold
        document.getElementById('textThresholdValue').textContent = this.textThreshold + ''
      }
      
      // 事件监听
      window.addEventListener('resize', this.onWindowResize)
      
      // 动画循环
      this.animate()
    },
    
    setupEventListeners() {
      // 鼠标事件
      document.addEventListener('mousedown', this.onMouseDown)
      document.addEventListener('mouseup', this.onMouseUp)
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('wheel', this.onWheel, { passive: false })
      
      // 触摸事件
      document.addEventListener('touchstart', this.onTouchStart)
      document.addEventListener('touchmove', this.onTouchMove, { passive: false })
      document.addEventListener('touchend', this.onTouchEnd)
      
      // 控制面板区域检测
      const controlsElement = document.querySelector('.controls')
      if (controlsElement) {
        controlsElement.addEventListener('mouseenter', () => {
          this.isPointerInControls = true
        })
        controlsElement.addEventListener('mouseleave', () => {
          this.isPointerInControls = false
        })
      }
    },
    
    onMouseDown(e) {
      this.isDragging = true
      this.previousMousePosition = {
        x: e.clientX,
        y: e.clientY
      }
    },
    
    onMouseUp() {
      this.isDragging = false
    },
    
    onMouseMove(e) {
      if (this.isPointerInControls) return
      if (this.isDragging) {
        const deltaMove = {
          x: e.clientX - this.previousMousePosition.x,
          y: e.clientY - this.previousMousePosition.y
        }

        const spherical = new THREE.Spherical().setFromVector3(this.targetCameraPosition)
        spherical.theta -= deltaMove.x * 0.005
        spherical.phi = THREE.MathUtils.clamp(spherical.phi - deltaMove.y * 0.005, 0.1, Math.PI - 0.1)

        this.targetCameraPosition.setFromSpherical(spherical)
        this.previousMousePosition = { x: e.clientX, y: e.clientY }
      }
    },
    
    onWheel(e) {
      e.preventDefault()
      const distance = this.targetCameraPosition.length()
      const newDistance = THREE.MathUtils.clamp(distance - e.deltaY * 0.01, 10, 80)
      
      if (document.getElementById('cameraDistance')) {
        document.getElementById('cameraDistance').value = newDistance
        document.getElementById('cameraValue').textContent = Math.round(newDistance)
      }
      
      this.targetCameraPosition.setLength(newDistance)
    },
    
    onTouchStart(e) {
      if (this.isPointerInControls) return

      if (e.touches.length === 1) {
        this.initialTouchPosition = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY
        }
      } else if (e.touches.length === 2) {
        const dx = e.touches[0].clientX - e.touches[1].clientX
        const dy = e.touches[0].clientY - e.touches[1].clientY
        this.touchStartDistance = Math.sqrt(dx * dx + dy * dy)
        e.preventDefault() // 阻止双指缩放的默认行为
      }
    },
    
    onTouchMove(e) {
      if (this.isPointerInControls) return

      if (e.touches.length === 1) {
        const touch = e.touches[0]
        const deltaMove = {
          x: touch.clientX - this.initialTouchPosition.x,
          y: touch.clientY - this.initialTouchPosition.y
        }

        const spherical = new THREE.Spherical().setFromVector3(this.targetCameraPosition)
        spherical.theta -= deltaMove.x * 0.005
        spherical.phi = THREE.MathUtils.clamp(spherical.phi - deltaMove.y * 0.005, 0.1, Math.PI - 0.1)

        this.targetCameraPosition.setFromSpherical(spherical)
        this.initialTouchPosition = { x: touch.clientX, y: touch.clientY }
      } else if (e.touches.length === 2) {
        const touch1 = e.touches[0]
        const touch2 = e.touches[1]
        const dx = touch1.clientX - touch2.clientX
        const dy = touch1.clientY - touch2.clientY
        const touchDistance = Math.sqrt(dx * dx + dy * dy)

        const distance = this.targetCameraPosition.length()
        const zoomFactor = touchDistance / this.touchStartDistance
        const newDistance = THREE.MathUtils.clamp(distance / zoomFactor, 10, 80)

        if (document.getElementById('cameraDistance')) {
          document.getElementById('cameraDistance').value = newDistance
          document.getElementById('cameraValue').textContent = Math.round(newDistance)
        }
        
        this.targetCameraPosition.setLength(newDistance)
        this.touchStartDistance = touchDistance
        e.preventDefault() // 阻止双指缩放的默认行为
      }
    },
    
    onTouchEnd() {
      this.touchStartDistance = 0
    },
    
    generateGlowTexture(width, height) {
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      const centerX = width / 2
      const centerY = height / 2
      const radius = Math.min(width, height) / 2
      
      const gradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius)
      gradient.addColorStop(0, 'rgba(255, 255, 255, 1)')
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0)')
      
      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, width, height)
      
      return new THREE.CanvasTexture(canvas)
    },
    
    createRings() {
      for (let i = 0; i < this.ringConfigs.length; i++) {
        const [innerRadius, outerRadius, color, opacity] = this.ringConfigs[i]
        const ringGeometry = new THREE.RingGeometry(innerRadius, outerRadius, 64)
        const ringMaterial = new THREE.MeshBasicMaterial({
          color: color,
          transparent: true,
          opacity: opacity,
          depthWrite: false
        })
        const ring = new THREE.Mesh(ringGeometry, ringMaterial)
        ring.rotation.x = Math.PI / 2
        this.scene.add(ring)
        this.rings.push(ring)
      }
    },
    
    getRandomParticlePosition() {
      const distance = 5 + Math.random() * this.distanceFactor
      const theta = Math.random() * Math.PI * 2
      const phi = Math.random() * Math.PI
      
      return new THREE.Vector3(
        distance * Math.sin(phi) * Math.cos(theta),
        distance * Math.sin(phi) * Math.sin(theta),
        distance * Math.cos(phi)
      )
    },
    
    createSingleParticle(i, living_data = null) {
      const geometry = new THREE.SphereGeometry(this.particleSize, 16, 16)
      let color, material
      if (living_data === null) {
        color = this.colors[Math.floor(Math.random() * this.colors.length)]
      } else {
        color = living_data.robotColour
      }
      
      material = new THREE.MeshPhysicalMaterial({
        color: color,
        emissive: color,
        emissiveIntensity: 1.5,
        roughness: 0.2,
        metalness: 0.1,
        clearcoat: 0.8,
        clearcoatRoughness: 0.1,
        transparent: true,
        opacity: 0.9
      })
      
      const particle = new THREE.Mesh(geometry, material)
      particle.scale.set(this.particleSize, this.particleSize, this.particleSize)
      
      // 添加随机位置初始化
      particle.position.copy(this.getRandomParticlePosition())
      
      // 统一userData格式
      const randomBaseSpeed = 0.05 + Math.random() * 0.15
      let id, living_name, living_birthday, rbyBirthday, keywords, styleOfLanguage, specifyName, defaultCatchphrase
      if (living_data === null) {
        id = i
        living_name = ['点子小机灵', '点子小佛', '点子小魔王', '点子小蹦豆', '点子小奶包', '指挥小机灵', '杠精小司令', '戏精小干部', '暖心小班长', '戏精小暖炉', '暖心小话痨', '戏精粘粘怪', '夸夸小粘怪', '萌想小乖宝', '奇思小乖宝', '元气小指挥', '懒懒小粘包', '呆萌小佛仙'][Math.floor(Math.random() * 18)]
        living_birthday = `${Math.floor(Math.random() * 24).toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`
        rbyBirthday = null
        keywords = null
        styleOfLanguage = null
        specifyName = null
        defaultCatchphrase = null
      } else {
        id = living_data.id
        living_name = living_data.specifyName
        rbyBirthday = living_data.robotBirthday
        living_birthday = living_data.robotBirthday + ' 出生'
        keywords = [living_data.robotKeyword1, living_data.robotKeyword2, living_data.robotKeyword3]
        styleOfLanguage = living_data.styleOfLanguage
        specifyName = living_data.specifyName
        defaultCatchphrase = living_data.defaultCatchphrase
      }
      
      particle.userData = {
        originalPosition: particle.position.clone(),
        distance: particle.position.length(),
        baseSpeed: randomBaseSpeed,
        speedVariation: (Math.random() - 0.5) * 0.5,
        trailPoints: [],
        color: color,
        text: {
          line1: living_name,
          line2: living_birthday
        },
        id: id,
        keywords: keywords,
        rbyBirthday: rbyBirthday,
        robotKeyword1: keywords ? keywords[0] : null,
        robotKeyword2: keywords ? keywords[1] : null,
        robotKeyword3: keywords ? keywords[2] : null,
        styleOfLanguage: styleOfLanguage,
        specifyName: specifyName,
        defaultCatchphrase: defaultCatchphrase
      }
      
      return particle
    },
    
    createParticleGlow(particle, color) {
      const glowTexture = this.generateGlowTexture(128, 128)
      const material = new THREE.SpriteMaterial({
        map: glowTexture,
        color: color,
        transparent: true,
        blending: THREE.AdditiveBlending,
        opacity: 0.9
      })
      
      const glow = new THREE.Sprite(material)
      glow.position.copy(particle.position)
      glow.scale.set(0.8, 0.8, 1)
      glow.userData = { particle: particle }
      this.scene.add(glow)
      this.glowMeshes.push(glow)
    },
    
    createParticleLabel(particle) {
      const labelContainer = document.createElement('div')
      labelContainer.className = 'particle-label-container'
      
      const labelDiv = document.createElement('div')
      labelDiv.className = 'particle-label'
      labelDiv.innerHTML = `
        <div class="label-line1">${particle.userData.text.line1}</div>
        <div class="label-line2">${particle.userData.text.line2}</div>
        <div class="label-position-guide"></div>
      `
      
      labelContainer.appendChild(labelDiv)
      const label = new CSS2DObject(labelContainer)
      
      // 同步粒子颜色
      labelDiv.style.color = `rgb(${Math.floor(particle.material.color.r * 255)},${Math.floor(particle.material.color.g * 255)},${Math.floor(particle.material.color.b * 255)})`
      
      // 添加点击交互
      labelDiv.style.pointerEvents = 'auto'
      labelDiv.addEventListener('click', () => {
        try {
          // 检查 particle.userData 是否存在
          if (!particle.userData) {
            console.error('粒子没有 userData 属性');
            return;
          }
          
          // 安全处理 defaultCatchphrase
          let audio_url = '';
          if (particle.userData.defaultCatchphrase) {
            audio_url = 'https://robot-rby.oss-cn-hangzhou.aliyuncs.com/rby-chat/audio_mp3/' + particle.userData.defaultCatchphrase + '-50.mp3';
            this.play_audio(audio_url);
          }
          
          let keywords_length = this.selectedKeywords.length;
          
          if (keywords_length >= 0) {
            TWEEN.removeAll();
            let data = particle.userData;
            
            // 安全设置 final_selected
            this.final_selected.id = data.id || 0;
            this.final_selected.robotKeyword1 = data.robotKeyword1 || '';
            this.final_selected.robotKeyword2 = data.robotKeyword2 || '';
            this.final_selected.robotKeyword3 = data.robotKeyword3 || '';
            this.final_selected.styleOfLanguage = data.styleOfLanguage || '';
            this.final_selected.rbyBirthday = data.rbyBirthday || '';
            this.final_selected.specifyName = data.specifyName || '';
            this.final_selected.defaultCatchphrase = data.defaultCatchphrase || '';
            this.final_selected.color = data.color || '';
            
            // 安全处理 currentCatchphrase
            let currentCatchphrase = this.final_selected.defaultCatchphrase || '未知';
            let tihuan = [['逼', '哔'], ['当', '铛'], ['嗞', '滋'], ['拎', '铃']];
            for (let i = 0; i < tihuan.length; i++) {
              currentCatchphrase = currentCatchphrase.replace(new RegExp(tihuan[i][0], 'g'), tihuan[i][1]);
            }
            
            // 安全更新 info 元素
            const infoElement = document.getElementById('info');
            if (infoElement) {
              infoElement.innerHTML = "<span style='font-size: 0.8em; color: #ffffff; font-weight: normal;'>已选择：" + this.final_selected.specifyName + "<br>性格特征：" + this.final_selected.robotKeyword1 + "、" + this.final_selected.robotKeyword2 + "、" + this.final_selected.robotKeyword3 + "<br>生日：" + this.final_selected.rbyBirthday + "<br>开口语：" + currentCatchphrase + "</span>";
            }
            
            // 启用选择按钮
            const selectLifeFormElement = document.getElementById('selectLifeForm');
            if (selectLifeFormElement) {
              selectLifeFormElement.disabled = false;
            }
            
            // 安全修改当前标签颜色为白色并添加边框
            if (this.labelCache[particle.id]) {
              const labelCacheEntry = this.labelCache[particle.id];
              if (labelCacheEntry && labelCacheEntry.element) {
                labelCacheEntry.element.style.color = '#ffffff';
                labelCacheEntry.element.style.border = '2px solid white';
                labelCacheEntry.element.style.borderRadius = '8px';
              }
            }
            
            // 安全重置其他标签颜色并移除边框
            if (this.particlesGroup) {
              this.particlesGroup.children.forEach(p => {
                if (p !== particle && this.labelCache[p.id]) {
                  const labelCacheEntry = this.labelCache[p.id];
                  if (labelCacheEntry && labelCacheEntry.element) {
                    labelCacheEntry.element.style.border = 'none';
                    labelCacheEntry.element.style.color = `rgb(${p.material.color.r * 255},${p.material.color.g * 255},${p.material.color.b * 255})`;
                  }
                }
              });
            }
            
            // 保持当前粒子放大状态
            new TWEEN.Tween(particle.scale)
              .to({ x: this.particleSize * 2.5, y: this.particleSize * 2.5, z: this.particleSize * 2.5 }, 200)
              .easing(TWEEN.Easing.Quadratic.Out)
              .chain(
                new TWEEN.Tween(particle.scale)
                  .to({ x: this.particleSize * 2, y: this.particleSize * 2, z: this.particleSize * 2 }, 400)
                  .easing(TWEEN.Easing.Elastic.Out)
              )
              .start();
            
            // 重置其他粒子大小
            if (this.particlesGroup) {
              this.particlesGroup.children.forEach(p => {
                if (p !== particle) {
                  new TWEEN.Tween(p.scale)
                    .to({ x: this.particleSize, y: this.particleSize, z: this.particleSize }, 400)
                    .easing(TWEEN.Easing.Elastic.Out)
                    .start();
                }
              });
            }
          } else {
            // 安全更新 selectLifeForm 元素
            const selectLifeFormElement = document.getElementById('selectLifeForm');
            if (selectLifeFormElement) {
              selectLifeFormElement.disabled = true;
            }
            
            // 原始动画逻辑
            new TWEEN.Tween(particle.scale)
              .to({ x: this.particleSize * 2.5, y: this.particleSize * 2.5, z: this.particleSize * 2.5 }, 200)
              .easing(TWEEN.Easing.Quadratic.Out)
              .chain(
                new TWEEN.Tween(particle.scale)
                  .to({ x: this.particleSize, y: this.particleSize, z: this.particleSize }, 400)
                  .easing(TWEEN.Easing.Elastic.Out)
              )
              .start();
          }
        } catch (error) {
          console.error('点击粒子时出错:', error);
        }
      })
      
      // 存储标签引用
      this.labelCache[particle.id] = {
        label: label,
        element: labelDiv,
        container: labelContainer
      }
      
      return label
    },
    
    createParticles(count = this.particleCount, living_datas = []) {
      // 清除旧粒子
      if (this.particlesGroup) {
        this.scene.remove(this.particlesGroup)
      }
      this.particlesGroup = new THREE.Group()
      this.scene.add(this.particlesGroup)
      
      // 清除旧标签和辉光
      this.clearAllLabels()
      while (this.glowMeshes.length) {
        this.scene.remove(this.glowMeshes.pop())
      }
      
      // 确定实际要创建的粒子数量
      const actualCount = living_datas.length > 0 ? living_datas.length : count
      
      for (let i = 0; i < actualCount; i++) {
        let particle
        if (living_datas.length > 0) {
          particle = this.createSingleParticle(i, living_datas[i])
        } else {
          particle = this.createSingleParticle(i)
        }
        this.particlesGroup.add(particle)
        this.createParticleGlow(particle, particle.material.color)
        
        // 创建标签
        const label = this.createParticleLabel(particle)
        this.scene.add(label)
      }
    },
    
    updateParticles(newCount) {
      const currentCount = this.particlesGroup ? this.particlesGroup.children.length : 0
      
      if (newCount > currentCount) {
        // 增加粒子
        if (this.keywordMode) {
          this.addParticlesWithDelay()
        } else {
          for (let i = currentCount; i < newCount; i++) {
            const particle = this.createSingleParticle(i)
            this.particlesGroup.add(particle)
            this.createParticleGlow(particle, particle.material.color)
            const label = this.createParticleLabel(particle)
            this.scene.add(label)
          }
        }
      } else if (newCount < currentCount) {
        if (this.keywordMode) {
          this.removeParticlesWithDelay(newCount)
        } else {
          // 删除多余粒子 (默认逻辑)
          const toRemove = currentCount - newCount
          for (let i = 0; i < toRemove; i++) {
            if (!this.particlesGroup || this.particlesGroup.children.length === 0) break
            const particle = this.particlesGroup.children[this.particlesGroup.children.length - 1]
            if (this.labelCache[particle.id]) {
              this.scene.remove(this.labelCache[particle.id].label)
              delete this.labelCache[particle.id]
            }
            
            // 精确匹配辉光对象
            const glowIndex = this.glowMeshes.findIndex(g => g.userData.particle === particle)
            if (glowIndex > -1) {
              this.scene.remove(this.glowMeshes[glowIndex])
              this.glowMeshes.splice(glowIndex, 1)
            }
            
            this.particlesGroup.remove(particle)
            particle.geometry.dispose()
            particle.material.dispose()
          }
        }
      }
    },
    
    addParticlesWithDelay() {
      let index = 0
      const addParticle = () => {
        if (index >= this.particles_deleted.length) return
        
        const batchSize = 10
        const endIndex = Math.min(index + batchSize, this.particles_deleted.length)
        
        for (let i = index; i < endIndex; i++) {
          const particle = this.particles_deleted[i]
          const selectedKeys = this.selectedKeywords
          const hasKeyword = selectedKeys.every(sk => particle.userData.keywords?.includes(sk))
          if (hasKeyword) {
            this.particlesGroup.add(particle)
            particle.visible = true
            const glowIndex = this.glowMeshes.findIndex(g => g.userData.particle === particle)
            if (glowIndex > -1) {
              this.scene.add(this.glowMeshes[glowIndex])
            }
            if (this.labelCache[particle.id]) {
              this.scene.add(this.labelCache[particle.id].label)
            }
          }
        }
        
        index = endIndex
        if (index < this.particles_deleted.length) {
          setTimeout(addParticle.bind(this), 20)
        }
      }
      addParticle()
    },
    
    removeParticlesWithDelay() {
      let index = this.particlesGroup ? this.particlesGroup.children.length - 1 : -1
      const removeParticle = () => {
        if (index < 0) return
        
        const batchSize = 10
        const endIndex = Math.max(index - batchSize, -1)
        
        for (let i = index; i > endIndex; i--) {
          if (!this.particlesGroup || i >= this.particlesGroup.children.length) continue
          const particle = this.particlesGroup.children[i]
          if (particle === undefined) continue
          
          const selectedKeys = this.selectedKeywords
          const hasKeyword = selectedKeys.every(sk => particle.userData.keywords?.includes(sk))
          if (selectedKeys.length === 0 || hasKeyword) continue
          
          // 删除关联辉光
          const glowIndex = this.glowMeshes.findIndex(g => g.userData.particle === particle)
          if (glowIndex > -1) {
            this.scene.remove(this.glowMeshes[glowIndex])
          }
          
          // 删除标签
          if (this.labelCache[particle.id]) {
            this.scene.remove(this.labelCache[particle.id].label)
          }
          if (this.final_selected.id === particle.userData.id) {
            this.final_selected.id = 0
            const infoElement = document.getElementById('info')
            if (infoElement) {
              infoElement.innerHTML = '等待选择'
            }
            const selectLifeFormElement = document.getElementById('selectLifeForm')
            if (selectLifeFormElement) {
              selectLifeFormElement.disabled = true
            }
          }
          
          this.particlesGroup.remove(particle)
          particle.visible = false
          this.particles_deleted.push(particle)
        }
        
        index = endIndex
        if (index >= 0) {
          setTimeout(removeParticle.bind(this), 20)
        }
      }
      removeParticle()
    },
    
    clearAllLabels() {
      Object.keys(this.labelCache).forEach(key => {
        const { label } = this.labelCache[key]
        if (label) {
          this.scene.remove(label)
        }
        delete this.labelCache[key]
      })
    },
    
    animate() {
      this.animationId = requestAnimationFrame(this.animate)
      
      TWEEN.update()
      
      // 更新光环朝向
      this.rings.forEach(ring => {
        if (this.camera) {
          ring.quaternion.copy(this.camera.quaternion)
        }
      })
      
      const elapsedTime = this.clock.getElapsedTime()
      
      // 更新粒子
      if (this.particlesGroup) {
        this.particlesGroup.children.forEach(particle => {
          const speed = particle.userData.baseSpeed * this.rotationSpeed
          const originalPos = particle.userData.originalPosition || particle.position
          const newX = originalPos.x * Math.cos(speed * elapsedTime) -
            originalPos.z * Math.sin(speed * elapsedTime)
          const newZ = originalPos.x * Math.sin(speed * elapsedTime) +
            originalPos.z * Math.cos(speed * elapsedTime)
          particle.position.set(
            newX,
            particle.position.y,
            newZ
          )
          this.updateGlowPosition(particle)
        })
      }
      
      // 中心点脉动效果
      if (this.celestialGroup) {
        const scaleFactor = 1 + Math.sin(elapsedTime * 2) * 0.1
        this.celestialGroup.scale.set(scaleFactor, scaleFactor, scaleFactor)
      }
      
      if (this.centerGlow) {
        const scaleFactor = 1 + Math.sin(elapsedTime * 2) * 0.1
        this.centerGlow.scale.set(10.0 * scaleFactor, 10.0 * scaleFactor, 1.0)
      }
      
      // 更新所有光环的脉动效果
      this.rings.forEach((ring, index) => {
        const phase = this.ringConfigs[index] && this.ringConfigs[index][4] ? this.ringConfigs[index][4] : 0
        const ringScale = 1 + Math.sin(elapsedTime * 2 + phase) * 0.1
        ring.scale.set(ringScale, ringScale, 1)
      })
      
      // 粒子脉动效果
      const sizeVariation = 0.15 * Math.sin(elapsedTime * 1.5)
      const currentSize = 1.2 + sizeVariation
      
      // 更新粒子光晕
      this.glowMeshes.forEach(glow => {
        if (glow.userData.particle) {
          glow.position.copy(glow.userData.particle.position)
          const particleSize = glow.userData.particle.scale.x
          const baseGlowSize = particleSize * 1.6
          const finalSize = baseGlowSize * currentSize
          glow.scale.set(finalSize, finalSize, 1)
        }
      })
      
      // 平滑相机移动
      this.updateCameraPosition()
      
      // 更新光源组方向与摄像机同步
      if (this.lightGroup && this.camera) {
        this.lightGroup.quaternion.copy(this.camera.quaternion)
      }
      
      // 渲染场景
      if (this.renderer && this.scene && this.camera) {
        this.renderer.render(this.scene, this.camera)
      }
      if (this.labelRenderer && this.scene && this.camera) {
        this.labelRenderer.render(this.scene, this.camera)
      }
      
      // 更新标签位置和可见性
      this.updateLabels()
      
      // 避免标签重叠
      this.avoidLabelOverlap()
      
      // 确保标签显示在粒子下方
      this.resetLabelPositions()
    },
    
    updateCameraPosition() {
      if (this.camera && this.targetCameraPosition) {
        this.camera.position.lerp(this.targetCameraPosition, 0.08)
        this.camera.lookAt(this.scene.position)
      }
    },
    
    updateDistanceFactor(factor) {
      if (this.particlesGroup) {
        this.particlesGroup.children.forEach(particle => {
          let distance
          if (particle.userData.distanceFactor === undefined) {
            distance = 5 + Math.random() * factor
            particle.userData.distanceFactor = distance
          } else {
            distance = particle.userData.distanceFactor
          }
          const position = particle.userData.originalPosition.clone().normalize().multiplyScalar(distance)
          particle.userData.originalPosition = position
          particle.userData.distance = distance
        })
      }
    },
    
    updateLabels() {
      if (!this.particlesGroup) return
      
      // 获取当前时间，用于动态显示控制
      const currentTime = Date.now()
      
      // 控制标签更新频率，避免频繁变化
      if (currentTime - this.lastLabelUpdateTime < this.labelUpdateInterval) {
        // 如果时间间隔不足，保持当前可见标签不变
        return
      }
      
      // 清空可见标签数组
      this.visibleLabels = []
      
      // 更新上次标签更新时间
      this.lastLabelUpdateTime = currentTime
      
      // 计算距离并排序
      const particleDistances = this.particlesGroup.children
        .map(particle => ({
          particle,
          distance: particle.position.distanceTo(this.camera.position)
        }))
        .sort((a, b) => a.distance - b.distance)
      
      // 控制显示标签数量，只显示少数几个
      const maxVisibleLabels = 3 // 只显示3个标签
      
      // 添加随机性，让标签显示更有变化感
      let visibleParticles = particleDistances
        .slice(0, 10) // 先取前10个最近的粒子
        .sort(() => Math.random() - 0.5) // 随机排序
        .slice(0, maxVisibleLabels) // 再取前3个
        .map(item => item.particle)
      
      // 标记可见标签
      visibleParticles.forEach(particle => {
        this.visibleLabels.push(particle.id)
      })
      
      // 更新标签可见性
      this.updateLabelVisibility()
    },
    
    updateLabelVisibility() {
      // 添加新可见标签的淡入效果
      for (const particleId of this.visibleLabels) {
        const cacheItem = this.labelCache[particleId]
        if (!cacheItem) continue
        
        const { element } = cacheItem
        if (element && !element.classList.contains('visible')) {
          element.classList.add('visible')
        }
      }
      
      // 隐藏不再可见的标签（带淡出效果）
      for (const particleIdStr in this.labelCache) {
        const particleId = Number(particleIdStr)
        if (!this.visibleLabels.includes(particleId)) {
          const { element } = this.labelCache[particleIdStr]
          if (element && element.classList.contains('visible')) {
            element.classList.remove('visible')
          }
        }
      }
    },
    
    avoidLabelOverlap() {
      const labelPositions = new Map()
      
      // 检查当前可见标签是否重叠
      for (const particleId of this.visibleLabels) {
        const cacheItem = this.labelCache[particleId]
        if (!cacheItem) continue
        
        const { container } = cacheItem
        if (!container) continue
        
        const rect = container.getBoundingClientRect()
        labelPositions.set(particleId, {
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
          particleId: particleId
        })
      }
      
      const labelArray = Array.from(labelPositions.values())
      
      // 检查重叠并调整位置
      for (let i = 0; i < labelArray.length; i++) {
        for (let j = i + 1; j < labelArray.length; j++) {
          const rect1 = labelArray[i]
          const rect2 = labelArray[j]
          
          if (this.isOverlapping(rect1, rect2)) {
            // 为后出现的标签添加垂直偏移
            const adjustment = 0.5
            if (this.labelCache[rect2.particleId]) {
              this.labelCache[rect2.particleId].label.position.y -= adjustment
            }
          }
        }
      }
    },
    
    isOverlapping(rect1, rect2) {
      return !(
        rect1.x + rect1.width < rect2.x ||
        rect2.x + rect2.width < rect1.x ||
        rect1.y + rect1.height < rect2.y ||
        rect2.y + rect2.height < rect1.y
      )
    },
    
    resetLabelPositions() {
      if (!this.particlesGroup) return
      
      this.particlesGroup.children.forEach(particle => {
        const cache = this.labelCache[particle.id]
        if (cache) {
          cache.label.position.copy(
            particle.position.clone().add(new THREE.Vector3(0, 0, 0))
          )
        }
      })
    },
    
    updateGlowPosition(particle) {
      const particleId = particle.uuid
      for (const glow of this.glowMeshes) {
        if (glow.userData.particle && glow.userData.particle.uuid === particleId) {
          glow.position.copy(particle.position)
          break
        }
      }
    },
    
    onWindowResize() {
      if (!this.camera || !this.renderer || !this.labelRenderer) return
      
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.labelRenderer.setSize(window.innerWidth, window.innerHeight)
    },
    
    toggleControls() {
      this.isControlsCollapsed = !this.isControlsCollapsed
    },
    
    updateRotationSpeed() {
      if (document.getElementById('speedValue')) {
        document.getElementById('speedValue').textContent = this.rotationSpeed.toFixed(2)
      }
    },
    
    updateParticleSize() {
      if (this.particlesGroup) {
        this.particlesGroup.children.forEach(particle => {
          particle.scale.set(this.particleSize, this.particleSize, this.particleSize)
        })
      }
      if (document.getElementById('sizeValue')) {
        document.getElementById('sizeValue').textContent = this.particleSize.toFixed(1)
      }
    },
    
    updateParticleCount() {
      this.updateParticles(this.particleCount)
      if (document.getElementById('countValue')) {
        document.getElementById('countValue').textContent = this.particleCount
      }
    },
    
    updateCameraDistance() {
      this.targetCameraPosition.setLength(this.cameraDistance)
      if (document.getElementById('cameraValue')) {
        document.getElementById('cameraValue').textContent = this.cameraDistance
      }
    },
    
    updateTextThreshold() {
      if (document.getElementById('textThresholdValue')) {
        document.getElementById('textThresholdValue').textContent = this.textThreshold
      }
    },
    
    setupDatePicker() {
      const datePicker = document.getElementById('datePicker')
      if (datePicker) {
        const today = new Date()
        const oneYearAgo = new Date()
        oneYearAgo.setFullYear(today.getFullYear() - 1)

        // 设置最大日期为昨天
        const yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)

        datePicker.max = `${yesterday.getFullYear()}-${String(yesterday.getMonth()+1).padStart(2, '0')}-${String(yesterday.getDate()).padStart(2, '0')}`
        datePicker.min = oneYearAgo.toISOString().split('T')[0]

        // 默认设置为昨天
        datePicker.value = yesterday.toISOString().split('T')[0]
        this.selectedDate = datePicker.value
        this.currentZodiac = this.getZodiac(yesterday)
        this.updateZodiacButtons(yesterday)
      }
    },
    
    handleDateChange() {
      const date = new Date(this.selectedDate)
      this.currentZodiac = this.getZodiac(date)
      this.updateZodiacButtons(date)
      this.getLivingInfos()
    },
    
    getZodiac(date) {
      const month = date.getMonth() + 1
      const day = date.getDate()
      
      if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return '白羊座'
      if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return '金牛座'
      if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return '双子座'
      if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return '巨蟹座'
      if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return '狮子座'
      if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return '处女座'
      if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return '天秤座'
      if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return '天蝎座'
      if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return '射手座'
      if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return '摩羯座'
      if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return '水瓶座'
      if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return '双鱼座'
    },
    
    updateZodiacButtons(date) {
      const zodiac = this.getZodiac(date)
      const allowedButtons = this.zodiacMap[zodiac] || []
      
      // 重置所有按钮状态
      this.selectedKeywords = []
    },
    
    isKeywordDisabled(keyword) {
      const date = new Date(this.selectedDate)
      const zodiac = this.getZodiac(date)
      const allowedButtons = this.zodiacMap[zodiac] || []
      return this.zodiacButtons.includes(keyword) && !allowedButtons.includes(keyword)
    },
    
    handleKeywordButtonClick(keyword, element) {
      if (element && element.style && element.style.opacity && element.style.opacity < 1) {
        const matchedZodiacs = Object.entries(this.zodiacMap)
          .filter(([, traits]) => traits.includes(keyword))
          .map(([zodiac]) => zodiac)
          .slice(0, 3)
        this.showInfoModal = true
        this.infoModalContent = `该特征仅在以下星座可用：<br>${matchedZodiacs.join('、')}`
        return
      }
      
      const index = this.selectedKeywords.indexOf(keyword)
      
      if (index === -1) {
        // 检查互斥组
        for (const group of this.exclusiveGroups) {
          if (group.includes(keyword)) {
            const otherKeyword = group.find(item => item !== keyword)
            const otherIndex = this.selectedKeywords.indexOf(otherKeyword)
            if (otherIndex !== -1) {
              this.selectedKeywords.splice(otherIndex, 1)
            }
          }
        }
        
        // 检查是否已达最大数量
        if (this.selectedKeywords.length >= 3) {
          this.selectedKeywords.pop()
        }
        
        this.selectedKeywords.push(keyword)
        
        // 三维逻辑
        let keyword_length = this.selectedKeywords.length
        if (keyword_length == 3) {
          this.updateDistanceFactor(1)
          this.targetCameraPosition.setLength(15)
        }
        else if (keyword_length == 2) {
          this.updateDistanceFactor(7)
          this.targetCameraPosition.setLength(20)
        }
        else if (keyword_length == 1) {
          this.updateDistanceFactor(10)
          this.targetCameraPosition.setLength(25)
        }
        this.particleSize = (this.selectedKeywords.length + 3) / 10
        this.updateParticleSize()
        
        setTimeout(() => {
          this.updateParticles(1)
        }, 100)
      } else {
        // 取消选中
        this.selectedKeywords.splice(index, 1)
        
        let keyword_length = this.selectedKeywords.length
        if (keyword_length == 2) {
          this.updateDistanceFactor(7)
          this.targetCameraPosition.setLength(20)
        }
        else if (keyword_length == 1) {
          this.updateDistanceFactor(10)
          this.targetCameraPosition.setLength(25)
        }
        else {
          this.updateDistanceFactor(15)
          this.targetCameraPosition.setLength(30)
        }
        this.particleSize = (this.selectedKeywords.length + 3) / 10
        this.updateParticleSize()
        
        setTimeout(() => {
          this.updateParticles(1000000)
        }, 100)
      }
    },
    
    toggleDateContainer() {
      this.isDateContainerCollapsed = !this.isDateContainerCollapsed
    },
    
    handleButtonClick(type) {
      switch (type) {
        case 1:
          this.playOpeningAnimation()
          break
        case 2:
          this.loadRealData()
          break
        case 3:
          this.reduceLifeForms()
          break
        case 4:
          this.addLifeForms()
          break
      }
    },
    
    playOpeningAnimation() {
      // 开屏动画
      new TWEEN.Tween(this.camera.position)
        .to({ z: 100 }, 2000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .start()
    },
    
    loadRealData() {
      // 加载真实数据
      this.getLivingInfos()
    },
    
    reduceLifeForms() {
      // 选词减生命体
      if (this.particleCount > 50) {
        this.particleCount -= 50
        this.init('system')
      }
    },
    
    addLifeForms() {
      // 去词加生命体
      if (this.particleCount < 2000) {
        this.particleCount += 50
        this.init('system')
      }
    },
    
    handlePersonalityChange() {
      // 性格变化处理
      this.init('system')
    },
    
    selectLifeForm() {
      // 生成随机码
      const code = this.generateSixDigitNumber()
      let intervalId = setInterval(() => {
        let code_temp = this.generateSixDigitNumberTemp()
        this.codeDigits = code_temp.split('')
        this.showCodeModal = true
      }, 50)
      
      // 发送数据到API
      request.post('/api/robot/addRobotSelectInfo', {
        id: code,
        content: this.final_selected,
        creat_time: this.getCurrentDateTime()
      })
      .then(data => {
        clearInterval(intervalId)
        if (data.success && data.operation == "inserted") {
          this.codeDigits = code.split('')
          this.showCodeModal = true
        }
      })
      .catch(error => {
        clearInterval(intervalId)
        console.error('API调用失败:', error)
      })
    },
    
    generateSixDigitNumberTemp() {
      const digits = new Set()
      while (digits.size < 6) {
        const num = Math.floor(Math.random() * 10)
        if (digits.size === 0 || num !== Array.from(digits).pop()) {
          digits.add(num)
        }
      }
      return Array.from(digits).join('')
    },
    
    generateSixDigitNumber() {
      const timestamp = Date.now()
      const timestampStr = timestamp.toString()
      let sixDigits = timestampStr.slice(-6)
      if (sixDigits.length < 6) {
        sixDigits = sixDigits.padEnd(6, Math.floor(Math.random() * 10))
      }
      sixDigits = sixDigits[0] + sixDigits[3] + sixDigits[1] + sixDigits[5] + sixDigits[2] + sixDigits[4]
      return sixDigits
    },
    
    getCurrentDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    getLivingInfos() {
      this.isLoading = true
      const date = this.selectedDate || new Date().toISOString().split('T')[0]
      
      request.post('/api/robot/getRobotByKeyWord', {
        robotDate: date
      })
      .then(data => {
        if (data.success) {
          this.livingInfos = data.data || []
          this.living_infos_default = this.livingInfos
          this.init('real_data')
        }
      })
      .catch(error => {
        console.error('获取生命体数据失败:', error)
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    
    play_audio(url) {
      const audio = this.$refs.audioPlayer
      if (audio) {
        audio.src = url
        audio.play().catch(error => {
          console.error('音频播放失败:', error)
        })
      }
    },
    
    cleanup() {
      // 清除动画循环
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
      }
      
      // 清除事件监听器
      window.removeEventListener('resize', this.onWindowResize)
      document.removeEventListener('mousedown', this.onMouseDown)
      document.removeEventListener('mouseup', this.onMouseUp)
      document.removeEventListener('mousemove', this.onMouseMove)
      document.removeEventListener('wheel', this.onWheel)
      document.removeEventListener('touchstart', this.onTouchStart)
      document.removeEventListener('touchmove', this.onTouchMove)
      document.removeEventListener('touchend', this.onTouchEnd)
      
      // 清除粒子和标签
      if (this.particlesGroup) {
        this.scene.remove(this.particlesGroup)
        this.particlesGroup.children.forEach(particle => {
          particle.geometry.dispose()
          particle.material.dispose()
        })
      }
      
      // 清除光环
      this.rings.forEach(ring => {
        this.scene.remove(ring)
        ring.geometry.dispose()
        ring.material.dispose()
      })
      
      // 清除辉光
      this.glowMeshes.forEach(glow => {
        this.scene.remove(glow)
        glow.material.dispose()
      })
      
      // 清除标签
      this.clearAllLabels()
      
      // 清除渲染器
      if (this.renderer) {
        this.renderer.dispose()
      }
      
      if (this.labelRenderer) {
        this.labelRenderer.dispose()
      }
    },
    
    showInfo(content) {
      this.showInfoModal = true
      this.infoModalContent = content
    },
    
    closeInfoModal() {
      this.showInfoModal = false
    },
    
    closeCodeModal() {
      this.showCodeModal = false
    },
    
    copyCode() {
      const code = this.codeDigits.join('')
      navigator.clipboard.writeText(code).catch(error => {
        console.error('复制失败:', error)
      })
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  overflow: hidden;
  background:
    radial-gradient(ellipse at 10% 20%,
      rgba(30, 58, 138, 0.3) 0%,
      transparent 30%),
    radial-gradient(ellipse at 90% 80%,
      rgba(129, 52, 175, 0.2) 0%,
      transparent 30%),
    radial-gradient(ellipse at 50% 30%,
      rgba(0, 200, 200, 0.2) 0%,
      transparent 50%),
    linear-gradient(135deg,
      rgba(8, 12, 48, 1) 0%,
      rgba(4, 7, 30, 1) 50%,
      rgba(2, 4, 20, 1) 100%);
  font-family: 'Arial', sans-serif;
  color: #fff;
}

canvas {
  display: block;
}

#container {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.controls {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.7);
  padding: 15px;
  border-radius: 10px;
  z-index: 1000;
  min-width: 300px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 20px rgba(78, 204, 163, 0.3);
}

.controls h2 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #4ecca3;
  font-size: 1.5rem;
  text-shadow: 0 0 10px rgba(78, 204, 163, 0.9);
  text-align: center;
}

.control-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.9rem;
  color: #e0e0ff;
}

input[type="range"] {
  width: 100%;
  margin-bottom: 5px;
  background: rgba(100, 150, 255, 0.1);
  border-radius: 5px;
  height: 5px;
  -webkit-appearance: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4ecca3;
  cursor: pointer;
  box-shadow: 0 0 8px rgba(78, 204, 163, 0.8);
}

.value-display {
  font-size: 0.8rem;
  color: #aaa;
  margin-top: 5px;
}

.btn {
  display: block;
  width: 100%;
  background: linear-gradient(45deg, #4ecca3, #41a88d);
  border: none;
  color: white;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.3s;
  box-shadow: 0 0 12px rgba(78, 204, 163, 0.7);
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

.btn::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -60%;
  width: 20px;
  height: 200%;
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(25deg);
  transition: all 0.6s;
}

.btn:hover,
.select-menu:focus {
  transform: translateY(-2px);
  box-shadow: 0 0 20px rgba(78, 204, 163, 0.9);
}

/* 下拉菜单专属样式 */
.select-menu option {
  background: rgba(0, 0, 0, 0.9);
  color: white;
  text-align: center;
  padding: 8px 12px;
}

.select-menu:focus option:checked {
  background: rgba(78, 204, 163, 0.7);
}

.select-menu {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 8px 35px 8px 15px;
  font-size: 1rem;
  color: white;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%234ecca3'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  scrollbar-color: #4ecca3 rgba(0, 0, 0, 0.5);
}

.btn:hover::after {
  left: 120%;
}

.btn1,
.select-menu {
  display: block;
  width: 100%;
  background: linear-gradient(45deg, #4fc6eb, #4668d8);
  border: none;
  color: white;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.3s;
  box-shadow: 0 0 12px rgba(78, 204, 163, 0.7);
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

.select-menu {
  background: linear-gradient(45deg, #ff9891, #ff59d6);
}

.btn1:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #4488e0;
}

.info {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(78, 204, 163, 0.2);
  text-align: center;
  font-weight: bold;
  color: #e0e0ff;
  z-index: 1000;
}

.title {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  text-shadow: 0 0 20px rgba(78, 204, 163, 0.9);
  color: white;
  z-index: 1000;
}

/* 粒子标签样式 - 添加淡入淡出效果 */
.particle-label {
  position: absolute;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 12px;
  border-radius: 4px;
  font-family: 'Microsoft YaHei', sans-serif;
  pointer-events: none;
  transition: opacity 0.5s ease, visibility 0.5s;
  transform: translate(-50%, calc(-100% - 20px));
  /* 置于粒子下方 */
  opacity: 0;
  visibility: hidden;
  z-index: 1;
}

.particle-label.visible {
  opacity: 1;
  visibility: visible;
}

.label-line1 {
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  text-align: center;
}

.label-line2 {
  font-size: 8px;
  opacity: 0.9;
  white-space: nowrap;
  text-align: center;
}

/* 验证码弹窗样式 */
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
}

.modal-content-container {
  position: absolute;
  top: 20%;
  left: 50%;
  min-width: 300px;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(78, 204, 163, 0.2);
  text-align: center;
  z-index: 1000;
}

.code-display {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.scroll-content::-webkit-scrollbar {
  width: 8px;
}

.scroll-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.scroll-content::-webkit-scrollbar-thumb {
  background: #4ecca3;
  border-radius: 4px;
}

.code-digit {
  width: 40px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
}

.modal-buttons {
  display: flex;
  gap: 15px;
  padding: 8px 0;
}

.btn1 {
  min-width: 80px;
  padding: 8px 20px;
}

/* 标签位置微调 */
.particle-label-container {
  position: relative;
  pointer-events: none;
}

.hidden-audio {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  pointer-events: none;
}

/* 新增日期和按钮组件样式 */
.date-button-container {
  position: absolute;
  bottom: 90px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(78, 204, 163, 0.2);
  text-align: center;
  z-index: 1000;
  transition: all 0.3s ease;
  overflow: hidden;
}

.date-button-container.collapsed {
  width: 64px;
  height: 26px;
  padding: 8px;
}

.toggle-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 70px;
  height: 30px;
  border-radius: 10%;
  background: #2f3a52;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px rgba(78, 204, 163, 0.5);
}

.collapsed .date-picker,
.collapsed .button-grid,
.collapsed br,
.collapsed>div {
  display: none;
}

.date-picker {
  background: rgba(100, 150, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 15px;
  width: 200px;
  text-align: center;
  font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  cursor: pointer;
  position: relative;
  font-size: 20px;
}

/* 使整个输入框可点击 */
.date-picker::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: transparent;
  background: transparent;
}

/* 针对日期选择器中的数字和符号 */
.date-picker::-webkit-datetime-edit {
  font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
}

.date-picker::-webkit-inner-spin-button,
.date-picker::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

.button-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

/* 第一组互斥按钮 */
.keyword-btn:nth-child(1),
.keyword-btn:nth-child(2) {
  background: linear-gradient(45deg, #1E90FF, #1C86EE);
}

/* 第二组互斥按钮 */
.keyword-btn:nth-child(5),
.keyword-btn:nth-child(6) {
  background: linear-gradient(45deg, #1E90FF, #1C86EE);
}

.keyword-btn:nth-child(3),
.keyword-btn:nth-child(4),
.keyword-btn:nth-child(7),
.keyword-btn:nth-child(8),
.keyword-btn:nth-child(9),
.keyword-btn:nth-child(10),
.keyword-btn:nth-child(11),
.keyword-btn:nth-child(12) {
  background: linear-gradient(45deg, #1E90FF, #1C86EE);
}

.keyword-btn {
  border: none;
  color: white;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  width: 72px;
}

.keyword-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(78, 204, 163, 0.7);
}

.keyword-btn.selected {
  background: linear-gradient(45deg, #ff59d6, #ff9891);
  box-shadow: 0 0 15px rgba(255, 89, 214, 0.7);
}

.keyword-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .controls {
    width: calc(100% - 40px);
    max-width: none;
    top: 70px;
    left: 20px;
    right: 20px;
  }

  .title {
    font-size: 1.5rem;
    top: 15px;
  }

  .info {
    text-align: center;
    font-size: 0.8rem;
  }
}

/* 折叠按钮样式 */
.toggle-controls {
  position: absolute;
  top: -30px;
  left: 0;
  width: 100%;
  height: 30px;
  cursor: pointer;
  z-index: 101;
}

.hamburger {
  width: 25px;
  height: 20px;
  position: relative;
  margin: 0 auto;
  transition: transform 0.3s ease-in-out;
}

.hamburger .bar {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 2px;
  background: #4ecca3;
  transition: all 0.3s;
  opacity: 0.5;
}

/* 折叠状态样式 */
.toggle-controls {
  top: 0;
  height: 10px;
  background: rgba(0, 0, 0, 0.7);
}

.controls {
  display: none;
  min-width: 300px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.controls.collapsed {
  height: 30px !important;
  padding: 0;
}

.controls.collapsed>*:not(.toggle-controls) {
  opacity: 0;
  pointer-events: none;
}

.hamburger {
  transform: none;
}

.controls.collapsed .bar:nth-child(1) {
  opacity: 1;
}
</style>
